export default __webpack_public_path__ + "static/media/TEMPLATE-ADMISSAO.fbb5bb36.png";